// extracted by mini-css-extract-plugin
export var aircallIframe = "_ld-3";
export var fabContainer = "_ld-5";
export var fabRinging = "_ld-6";
export var loadingOverlay = "_ld-4";
export var pulse = "_ld-7";
export var widgetContent = "_ld-2";
export var widgetPanel = "_ld-0";
export var widgetPanelExpanded = "_ld-1";